export default __webpack_public_path__ + "static/media/house-18.b51d8f96.jpg";